// config.js
const config = {
    API_BASE_URL: "https://musclefactorycostarica.com/api"
};

export default config;
